import { thingService } from '@/services/thing.service'
import { mapActions } from 'vuex'
import { DialogEventConfiguration } from "@/tools/dialog"
import { EventHub } from "@/constants/constants"

export default {
    name: 'EnterpriseEventsTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
        update: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        thingTypes: [],
        filteredThingTypes: [],
        validEventConfiguration: {},
        thingTypeFilter: null
    }),
    computed: {
    },
    created () {
        // Evento lanzado cuando se guarda una configuracion de eventos para un tipo de cosa
        this.$eventBus.$on(EventHub.COMMIT_EVENT_CONFIGURATION, (eventConfiguration) => {
            this.updateEventConfiguration(eventConfiguration)
        })
    },
    beforeDestroy() {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_EVENT_CONFIGURATION)
    },
    mounted () {
        this.getTypes()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        getTypes () {
            thingService.getTypesForSelector().then(response => {
                this.thingTypes.push(...response)
                this.filteredThingTypes.push(...response)
                this.getValidEventConfiguration()
            })
        },
        getValidEventConfiguration () {
            this.thingTypes.forEach(type => {
                const valid = !!this.model.events[type._id]
                this.validEventConfiguration[type._id] = {
                    tooltip: valid ? this.$t('enterprise.eventDialog.valid') : this.$t('enterprise.eventDialog.warning'),
                    icon: valid ? 'mdi-check-circle' : 'mdi-alert-circle',
                    color: valid ? 'success' : 'warning',
                }
            })
        },
        /**
         * Abre el dialog para editar la configuración de events para cada tipo de cosa
         * @param {*} level
         * @param {*} view
         */
        openEventDialog (typeId) {
            const bread = {
                key: DialogEventConfiguration,
                disabled: true,
                text: this.$t('events.name'),
                model: {
                    switchTypes: true,
                    enterpriseId: this.model.enterpriseId,
                    eventConfigurations: this.model.events,
                    eventTypes: this.eventTypes,
                    stateTypes: this.stateTypes,
                    types: this.thingTypes
                },
                update: this.update,
                selectedType: typeId
            }
            this.pushBread(bread)
        },
        /**
         * Luego de guardar la configuración de event en el dialog, actualizo los valores en el modelo
         * @param {*} eventConfiguration
         */
        updateEventConfiguration (eventConfiguration) {
            Object.assign(this.model.events, eventConfiguration)
            this.getValidEventConfiguration()
        },
        filterThingTypes () {
            if (this.thingTypeFilter) {
                this.filteredThingTypes = this.thingTypes.filter(t => t.name.toLowerCase().includes(this.thingTypeFilter.toLowerCase()))
            } else {
                this.filteredThingTypes.cleanAndUpdate(this.thingTypes)
            }
        }
    }
}
